import { JsonFilterPipe } from '../../filters/json-filter.pipe';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { CardEmployeesComponent } from '../../components/card-employees/card-employees.component';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { ItemInvitationComponent } from '../../components/item-invitation/item-invitation.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ListStatsComponent } from '../../components/list-stats/list-stats.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import Config from '../../utils/config.service';
import BusinessRestServices from '../../services/business-rest.service';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import DialogServices from '../../services/dialog.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import { ModalKomboDeactivateComponent } from '../../components/modal-kombo-deactivate/modal-kombo-deactivate.component';
import { PanelDirective } from '../../directives/panel.directive';
import { MatSelectModule } from '@angular/material/select';

@Component({
	standalone: true,
	selector: 'employees',
	templateUrl: './employees.component.html',
	imports: [
		CommonModule, MatSelectModule, PanelDirective, JsonFilterPipe, 
		LowerCasePipe, TranslatePipe, CardEmployeesComponent, ItemInfoPopoverComponent, 
		ItemInvitationComponent, LoaderOverlayComponent, ListStatsComponent, FormsModule
	]
})
export default class EmployeesView implements OnInit {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('employees').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.transitionDelay = 200;
		this.vm.transition = this.vm.transitionDelay + 'ms all ease';
		this.vm.isIntegrationEnabled = this.vm.user.businessUserType === 'BUSINESS_CLIENT';
		this.vm.invitationInfo = this.vm.user.businessUserType === 'SERVICE_OWNER'
			? this.angularFilterHelperService.translate('Employees.Invite_As_Service_Owner')
			: this.angularFilterHelperService.translate('Employees.Invite_As_Business_Owner');
		this.vm.isInviteEnabled = this.vm.user.businessUserType === 'SERVICE_OWNER'
			|| this.vm.user.service.walletType === 'EMPLOYER';
		this.vm.apiKey = null;
		this.vm.apiDetailsExpanded = false;
		this.vm.komboDetailsExpanded = false;
		this.vm.additionalInfoConfigs = ['NONE', 'LOCATION', 'GROUPS', 'LEGAL_ENTITY', 'CUSTOM'];
		if (this.vm.user.komboIntegration) {
			this.vm.komboIntegration = this.vm.user.komboIntegration;
			this.vm.komboDetailsExpanded = true;
			this.vm.komboIntegrationStarted = true;
			this.vm.komboFilters = this.vm.user.komboIntegration.filters;
			if (this.vm.user.komboIntegration.status == 'PENDING') {
				this.vm.komboPending = true;
			} else if (this.vm.user.komboIntegration.status == 'READY' || this.vm.user.komboIntegration.status == 'ACTIVE') {
				this.vm.komboConfigMode = true;
			}
		}
		
		this.getStats().then(() => { /* Stats loaded */ });
		
		this.vm.handleInvitationOpen = this.handleInvitationOpen;
		this.vm.handleInvitationClose = this.handleInvitationClose;
		this.vm.getIntegrationTranslation = this.getIntegrationTranslation;
		this.vm.generateApiKey = this.generateApiKey;
		this.vm.continueWithKombo = this.continueWithKombo;
		this.vm.openApiDetails = this.openApiDetails;
		this.vm.initKomboIntegration = this.initKomboIntegration;
		this.vm.getExistingKomboIntegration = this.getExistingKomboIntegration;
		this.vm.hasKomboFiltersOfType = this.hasKomboFiltersOfType;
		this.vm.isKomboFilterSelected = this.isKomboFilterSelected;
		this.vm.selectKomboFilter = this.selectKomboFilter;
		this.vm.saveKomboFilters = this.saveKomboFilters;
		this.vm.deactivateIntegration = this.deactivateIntegration;
		this.vm.resetKomboImport = this.resetKomboImport;
		this.vm.getIntegrationBaseUrl = this.getIntegrationBaseUrl;
		
		this.loadApiKey();
	};
	
	loadApiKey() {
		this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/api/key', { withCredentials: true })
		.subscribe((response: any) => {
			this.vm.apiKey = response.apiKey;
		});
	}
	
	generateApiKey() {
		this.httpClient.get(this.config.getRestUrl() + 'rest/business/service/generate/api/key', { withCredentials: true })
			.subscribe((response: any) => {
				this.vm.apiKey = response.apiKey;
			});
	}
	
	openApiDetails() {
		this.vm.apiDetailsExpanded = true;
	}
	
	saveKomboFilters() {
		if (this.vm.komboUpdateInProcess) {
			return;
		}
		this.vm.komboLoading = true;
		this.vm.komboUpdateInProcess = true;
		this.vm.komboUpdateFailed = false;
		this.vm.komboUpdateSuccessful = false;
		this.restService.saveUpdateKomboIntegration(this.vm.komboIntegration).then((integration) => {
			this.vm.komboUpdateSuccessful = true;
			this.vm.komboIntegration = integration;
			this.vm.komboFilters = integration.filters;
			this.vm.komboUpdateInProcess = false;
			this.vm.komboLoading = false;
		}).catch((error) => {
			this.vm.komboUpdateFailed = true;
			this.vm.komboUpdateInProcess = false;
			console.error(error);
			this.vm.komboLoading = false;
		});
	}
	
	resetKomboImport() {
		if (this.vm.komboUpdateInProcess) {
			return;
		}
		this.vm.komboLoading = true;
		this.vm.komboUpdateInProcess = true;
		this.vm.komboUpdateFailed = false;
		this.vm.komboUpdateSuccessful = false;
		this.restService.saveResetPendingKomboImportedEmployees({}).then((response) => {
			this.vm.komboUpdateSuccessful = true;
			this.vm.komboUpdateInProcess = false;
			this.vm.komboLoading = false;
			this.angularHelperService.getWindow().location.reload();
		}).catch((error) => {
			this.vm.komboUpdateFailed = true;
			this.vm.komboUpdateInProcess = false;
			this.vm.komboLoading = false;
			console.error(error);
		});
	}
	
	deactivateIntegration() {
		this.dialogServices.show({
			controller: ModalKomboDeactivateComponent
		});
	}
	
	getIntegrationBaseUrl() {
		if (this.vm.user.origin == 'siffi.com') {
			return "api.siffi.com";
		} else if (this.vm.user.origin && this.vm.user.origin.includes('minudoc')) {
			return "api.minudoc.ee";
		} else {
			return "www." + this.vm.user.origin;
		}
	}
	
	getExistingKomboIntegration() {
		this.vm.komboPending = false;
		this.vm.notReadyYet = false;
		this.restService.getExistingKomboIntegration({})
		.then((integration) => {
			this.vm.komboIntegration = integration;
			if (integration && (integration.status == 'READY' || integration.status == 'ACTIVE')) {
				if (integration.status == 'READY' && !integration.safeImportEnabled) {
					this.vm.komboIntegration.safeImportEnabled = true;
				}
				this.vm.komboConfigMode = true;
				this.vm.komboFilters = integration.filters;
			} else {
				this.vm.komboPending = true;
				this.vm.komboNotReady = true;
			}
			this.vm.komboLoading = false;
		}).catch((error) => {
			this.vm.komboPending = true;
			this.vm.notReadyYet = true;
			this.vm.komboLoading = false;
			console.error(error);
		});
	}
	
	selectKomboFilter(komboFilter) {
		komboFilter.applied = !komboFilter.applied;
	}
	
	isKomboFilterSelected(komboFilter) {
		return komboFilter.applied === true;
	}
	
	hasKomboFiltersOfType(type) {
		return this.vm.komboFilters && this.vm.komboFilters.filter((komboFilter) => { return komboFilter.type == type; }).length > 0;
	}
	
	continueWithKombo() {
		this.vm.komboDetailsExpanded = true;
	}
	
	initKomboIntegration(komboAlertForm: any) {
		if (this.vm.komboIntegrationStarted || komboAlertForm.invalid) {
			return;
		}
		this.vm.komboIntegrationStarted = true;
		
		var payload: any = {};
		payload.alertEmails = this.vm.komboEmail;
		
		this.restService.saveKomboIntegrationInit(payload).then((response) => {
			var komboInitLink: any = response.link;
			
			if (komboInitLink) {
				var promise: any = this.showKomboConnect(komboInitLink);
				
				promise.then((activationToken) => {
					var activationData: any = {};
					activationData.token = activationToken.activation_token;
					
					this.restService.saveKomboIntegrationActivate(activationData, {}).then((response) => {
						this.vm.komboPending = true;
					}).catch((error) => {
						console.error(error);
						this.vm.komboIntegrationStarted = false;
					});
				})
				.catch((err) => {
					console.error(err);
				});
			} else {
				console.log("Error initializing Kombo link.");
				this.vm.komboIntegrationStarted = false;
			}
		}).catch((error) => {
			console.error(error);
			this.vm.komboIntegrationStarted = false;
		});
	}
	
	showKomboConnect(url) {
		return new Promise((resolve, reject) => {
			if (this.vm.isOpen)
			return reject(new Error("There's already a Kombo Connect modal open!"));
			this.vm.isOpen = true;
			var frame: any = this.createIframe(url);
			document.body.append(frame);
			var closeFrame: any = () => {
				frame.remove();
				this.vm.isOpen = false;
			};
			var eventHandlers: any = {};
			eventHandlers.close = () => {
				closeFrame();
				this.vm.komboIntegrationStarted = false;
				reject(new Error("The user cancelled the flow!"));
			};
			eventHandlers.success = (activationToken) => {
				closeFrame();
				resolve(activationToken);
			};
			window.addEventListener("message", (event) => {
				if (event.source !== frame.contentWindow)
				return;
				var message: any = event.data;
				var eventHandler: any = eventHandlers[message.type];
				if (eventHandler)
				eventHandler(message.data);
			});
		});
	}
	
	createIframe(url) {
		var frame: any = document.createElement("iframe");
		frame.setAttribute("src", url);
		frame.setAttribute("allowtransparency", "true");
		frame.setAttribute("allow", "clipboard-read; clipboard-write");
		Object.assign(frame.style, {
			zIndex: Number.MAX_SAFE_INTEGER.toString(),
			position: "fixed",
			width: "100%",
			height: "100%",
			top: "0",
			bottom: "0",
			left: "0",
			right: "0"
		});
		return frame;
	}
	
	handleInvitationOpen(invitationType) {
		var allowedTypes: Array<any> = ['form', 'integration'];
		if (allowedTypes.indexOf(invitationType) === -1) return;
		this.vm.isInvitationOpen = true;
		this.vm.isStatsHidden = true;
		this.vm.invitationType = invitationType;
		if (this.vm.user.komboIntegration && this.vm.invitationType == 'integration') {
			this.vm.komboLoading = true;
			this.getExistingKomboIntegration();
		}
	}
	
	handleInvitationClose() {
		this.vm.isInvitationOpen = false;
		this.vm.apiDetailsExpanded = false;
		this.vm.komboUpdateFailed = false;
		this.vm.komboUpdateSuccessful = false;
		if (this.vm.user.komboIntegration) {
			this.vm.komboDetailsExpanded = true;
		} else {
			this.vm.komboDetailsExpanded = false;
		}
		this.vm.komboNotReady = false;
		this.angularHelperService.createTimer(() => { this.vm.isStatsHidden = false }, this.vm.transitionDelay);
	}
	
	getIntegrationTranslation() {
		if (this.vm.user.origin == 'siffi.com') {
			return this.angularFilterHelperService.translate('Employees.Integration_Info_Siffi');
		} else {
			return this.angularFilterHelperService.translate('Employees.Integration_Info');
		}
	}
	
	getStats() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var stats: Array<any> = [];
		
		this.businessRestServices.getDashboard().then(
			(res) => {
				stats.push({
					icon: 'user',
					label: this.angularFilterHelperService.translate('Dashboard.RegisteredUsers'),
					value: res.activeWorkerCount || 0
				});
				stats.push({
					icon: 'user',
					label: this.angularFilterHelperService.translate('Dashboard.NewUsersThisMonth'),
					value: res.activeWorkerCurrentMonthCount || 0
				});
				stats.push({
					icon: 'calendar-alt',
					label: this.angularFilterHelperService.translate('Dashboard.Interactions'),
					value: (res.bookingCurrentMonthCount || 0) + '/' + (res.bookingCount || 0),
				});
				if (res?.settings?.sessionLimit > 0) {
					stats.push({
						icon: 'hand',
						label: this.angularFilterHelperService.translate('Dashboard.Employees_Reached_Max_Limit'),
						value: res.totalUsersWhoReachedMaxLimit || 0,
					});
				}
				this.vm.stats = stats;
				deferred.resolve();
			}
		);
		
		return deferred.promise;
	}
	
}
